/* eslint-disable */

export enum OctopusResult {
  SUCCESS = "SUCCESS",
  GENERIC_FAILURE = "GENERIC_FAILURE",
  TRANSPORT_ERROR = "TRANSPORT_ERROR",
  UNSUPPORTED_INSTRUMENT = "UNSUPPORTED_INSTRUMENT",
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  INVALID_INSTRUMENT = "INVALID_INSTRUMENT",
  INSTRUMENT_EXPIRED = "INSTRUMENT_EXPIRED",
  CARD_LOST_OR_STOLEN = "CARD_LOST_OR_STOLEN",
  /**
   * INVALID_CVV - This could mean invalid CVV or invalid expiration date. Unfortunately,
   * this can't be discerned properly on the acquiring side. It also is not
   * precisely discernible on the issuer side due to limitations in the Virtual
   * card codes.
   */
  INVALID_CVV = "INVALID_CVV",
  DECLINED = "DECLINED",
  FAILED_TO_REACH_ISSUER = "FAILED_TO_REACH_ISSUER",
  LEASE_EXPIRED = "LEASE_EXPIRED",
  INVALID_ROUTING_NUMBER = "INVALID_ROUTING_NUMBER",
  CONTACT_ACQUIRER = "CONTACT_ACQUIRER",
  PICK_UP_CARD = "PICK_UP_CARD",
  SUSPECTED_FRAUD = "SUSPECTED_FRAUD",
  DO_NOT_HONOR = "DO_NOT_HONOR",
  REENTER_TRANSACTION = "REENTER_TRANSACTION",
  ACCOUNT_FROZEN = "ACCOUNT_FROZEN",
  /** FAILED_BANKBOOK_VALIDATION - A bank account failed Bankbook validation. */
  FAILED_BANKBOOK_VALIDATION = "FAILED_BANKBOOK_VALIDATION",
  /**
   * INVALID_BANKBOOK_ACCOUNT - Bank account is not valid. Does not include expired credentials
   * (E.g "INVALID_ACCOUNT_ID")
   */
  INVALID_BANKBOOK_ACCOUNT = "INVALID_BANKBOOK_ACCOUNT",
  /** BANKBOOK_CREDENTIALS_EXPIRED - Credentials associated to bank account(linked through Plaid) have expired. */
  BANKBOOK_CREDENTIALS_EXPIRED = "BANKBOOK_CREDENTIALS_EXPIRED",
  /**
   * POTENTIALLY_INSUFFICIENT_FUNDS - Risk determined that there are too many pending transactions
   * that may capture more than available funds for this transaction.
   */
  POTENTIALLY_INSUFFICIENT_FUNDS = "POTENTIALLY_INSUFFICIENT_FUNDS",
  /** INSTRUMENT_DISABLED - Customer disabled the instrument in app */
  INSTRUMENT_DISABLED = "INSTRUMENT_DISABLED",
  /** UNSUPPORTED_CURRENCY - We received a transaction in a currency that we don't support */
  UNSUPPORTED_CURRENCY = "UNSUPPORTED_CURRENCY",
  /** INVALID_AVS - Invalid, missing or mismatched Address verificiation */
  INVALID_AVS = "INVALID_AVS",
  /** UNACTIVATED_INSTRUMENT - The instrument has not yet been activated for use */
  UNACTIVATED_INSTRUMENT = "UNACTIVATED_INSTRUMENT",
  /** INVALID_PIN - The wrong PIN was entered at an ATM or POS terminal */
  INVALID_PIN = "INVALID_PIN",
  /** OVER_LIMIT - Transaction was attempted that exceeded one of the customer's transaction limit. */
  OVER_LIMIT = "OVER_LIMIT",
  /** TOO_MANY_ACTIVATION_ATTEMPTS - Too many seperate activations were attempted on singular device. */
  TOO_MANY_ACTIVATION_ATTEMPTS = "TOO_MANY_ACTIVATION_ATTEMPTS",
  /** MANUAL_REVIEW - Transaction must be manually reviewed */
  MANUAL_REVIEW = "MANUAL_REVIEW",
  /** UNSUPPORTED_COUNTRY - Transaction from unsupported country. */
  UNSUPPORTED_COUNTRY = "UNSUPPORTED_COUNTRY",
  /** CHIP_ERROR - Something went wrong with a EMV chip transaction. */
  CHIP_ERROR = "CHIP_ERROR",
  /** INVALID_AMOUNT - The amount of this transaction is somehow invalid. */
  INVALID_AMOUNT = "INVALID_AMOUNT",
  /** BLOCKED_BY_FRISKY - The transaction was declined by Frisky. */
  BLOCKED_BY_FRISKY = "BLOCKED_BY_FRISKY",
  /** RESTRICTED_CARD - The transaction declined as the card has some restrictions. */
  RESTRICTED_CARD = "RESTRICTED_CARD",
  /** TRANSACTION_NOT_PERMITTED - The transaction not permitted to the card holder. */
  TRANSACTION_NOT_PERMITTED = "TRANSACTION_NOT_PERMITTED",
  /**
   * AUTHENTICATION_REQUIRED - The transaction requires the customer to authenticate before
   * proceeding. e.g. 3DS.
   */
  AUTHENTICATION_REQUIRED = "AUTHENTICATION_REQUIRED",
  /** INVALID_MERCHANT - The transaction declined as the merchant is invalid. */
  INVALID_MERCHANT = "INVALID_MERCHANT",
  /**
   * INVALID_EXPIRATION - The transaction declined as the card was expired, expiration date is invalid or expiry date
   * not provided.
   */
  INVALID_EXPIRATION = "INVALID_EXPIRATION",
  /** SUSPECTED_STOLEN - The transaction declined due to suspected stolen. */
  SUSPECTED_STOLEN = "SUSPECTED_STOLEN",
  /** DECLINED_CARD_LOCKED - The transaction declined due to locked cards. */
  DECLINED_CARD_LOCKED = "DECLINED_CARD_LOCKED",
  /** UNSUPPORTED_MCC - The transaction declined due to unsupported mcc. */
  UNSUPPORTED_MCC = "UNSUPPORTED_MCC",
  /** ACCOUNT_DENYLISTED - The transaction declined due to denylisted account. */
  ACCOUNT_DENYLISTED = "ACCOUNT_DENYLISTED",
  /** ACCOUNT_EXTERNAL_SUSPENDED - The transaction declined due to suspended account. */
  ACCOUNT_EXTERNAL_SUSPENDED = "ACCOUNT_EXTERNAL_SUSPENDED",
  /** CARD_TERMINATED - The transaction declined due to card being terminated. */
  CARD_TERMINATED = "CARD_TERMINATED",
  /** UNSUPPORTED_REASON_CODE - The transaction declined due to unsupported transaction type. */
  UNSUPPORTED_REASON_CODE = "UNSUPPORTED_REASON_CODE",
  /** MOBILE_WALLET_ERROR - The transaction declined due to mobile wallet error. */
  MOBILE_WALLET_ERROR = "MOBILE_WALLET_ERROR",
  /**
   * STOP_PAYMENT - Roughly corresponds to Visa authorization error R0 (stop payment order). Generally this means
   * that someone (e.g. the customer) manually requested that the bank reject a payment.
   */
  STOP_PAYMENT = "STOP_PAYMENT",
  /**
   * REVOCATION_OF_AUTH - Roughly corresponds to Visa authorization errors R1 (revocation of authorization order) and R3
   * (revocation of all authorizations order). Very similar to STOP_PAYMENT, but generally means
   * that a customer asked the bank to reject either a specific auth, or all auths on a card.
   */
  REVOCATION_OF_AUTH = "REVOCATION_OF_AUTH",
  /**
   * MERCHANT_BLOCKED_FOR_SPONSORED_CUSTOMER - The transaction was declined because the merchant is blocked for sponsored
   * customers, such as firearms shops, etc.
   */
  MERCHANT_BLOCKED_FOR_SPONSORED_CUSTOMER = "MERCHANT_BLOCKED_FOR_SPONSORED_CUSTOMER",
  /** MERCHANT_BLOCKED_BY_CUSTOMER - The transaction was declined because the merchant was blocked by the customer. */
  MERCHANT_BLOCKED_BY_CUSTOMER = "MERCHANT_BLOCKED_BY_CUSTOMER",
  /** PIN_TRY_LIMIT_EXCEEDED - The transaction was declined because the offline pin try limit has been exceeded. */
  PIN_TRY_LIMIT_EXCEEDED = "PIN_TRY_LIMIT_EXCEEDED",
  /** AUTO_REVERSAL - The transaction was declined and flagged for auto reversal by Transaction Monitoring System */
  AUTO_REVERSAL = "AUTO_REVERSAL",
  /**
   * AUTO_REVERSAL_WITH_MANUAL_REVIEW - The transaction was declined and flagged for auto reversal with manual review
   * by Transaction Monitoring System
   */
  AUTO_REVERSAL_WITH_MANUAL_REVIEW = "AUTO_REVERSAL_WITH_MANUAL_REVIEW",
  /**
   * IN_APP_AUTHENTICATION_REQUIRED - The transaction was declined because in-app authentication was required.
   * This should only be used by legacy consumers of OctopusResult, such as Franklin.
   */
  IN_APP_AUTHENTICATION_REQUIRED = "IN_APP_AUTHENTICATION_REQUIRED",
  /** DUPLICATE_TRANSACTION - The transaction was declined and flagged as a duplicate transaction. */
  DUPLICATE_TRANSACTION = "DUPLICATE_TRANSACTION",
}
